export interface IPaymentType {
  key: string;
  description: string;
}